<template>
  <div class="bannerBox">
    <!-- <div class="playVedio" @mousemove="moveTo" @mouseleave="moveLeave" @click="modal1 = true">
      <div style="height:100px;width:100px" v-show="hover" id="demoCanvas1"></div>
      <div style="height:100px;width:100px" v-show="!hover" id="demoCanvas2"></div>
    </div> -->
    <div class="bannerBox_desc">
      <div
        class="bannerBox_desc_title flex align-center padding-lr-16 margin-bottom-sm"
      >
        <img
          src="../../../assets/img/index/bannerLeft.png"
          style="width: 78px; height: 10px"
          class="margin-right-xs"
          alt=""
        />
        <div class="text-16">
          2D、3D自由选择，PC、Android、iOS、iPad、H5多端数据互通
        </div>
        <img
          src="../../../assets/img/index/bannerRight.png"
          style="width: 78px; height: 10px"
          class="margin-left-xs"
          alt=""
        />
      </div>
      <div class="flex justify-start" style="">
        <div
          class="bannerBox_desc_btn flex flex-direction align-center justify-center text-14 radius-8"
          @click="$router.push('/engineDownload?tab=1')"
        >
          <div>996传奇引擎</div>
          <div>多端版</div>
        </div>
        <div
          class="bannerBox_desc_btn flex flex-direction align-center justify-center text-14 radius-8"
          @click="$router.push('/engineDownload?tab=2')"
        >
          <div>996传奇引擎</div>
          <div>PC版</div>
        </div>
        <div
          class="bannerBox_desc_btn flex flex-direction align-center justify-center text-14 radius-8"
          @click="$router.push('/engineDownload?tab=3')"
        >
          <div>996传世引擎</div>
          <div>多端版</div>
        </div>
        <div
          class="bannerBox_desc_btn flex flex-direction align-center justify-center text-14 radius-8"
          @click="$router.push('/engineDownload?tab=4')"
        >
          <div>996传奇引擎</div>
          <div>2.5D版</div>
        </div>
        <div
          class="bannerBox_desc_btn flex flex-direction align-center justify-center text-14 radius-8"
          @click="$router.push('/engineDownload?tab=5')"
        >
          <div>996传奇3引擎</div>
          <div>多端版</div>
        </div>
        <div
          class="bannerBox_desc_btn flex flex-direction align-center justify-center text-14 radius-8"
          @click="$router.push('/engineDownload?tab=6')"
        >
          <div>996 3D引擎</div>
          <div class="news">
            <img src="@/assets/img/index/news.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SVGA from "svgaplayerweb";
export default {
  name: "",
  data() {
    return {
      hover: false,
      imageNomal: "",
    };
  },
};
</script>

<style lang="less" scoped>
.bannerBox {
  position: relative;
  width: 100%;
  height: 660px;
  background: url("../../../assets/img/home/banner1019.png");
  background-size: cover;
  .bannerBox_desc {
    margin: 0 auto;
    text-align: left;
    width: 1226px;
    padding-top: 499px;
    .bannerBox_desc_title {
      height: 25px;
      font-family: PingFangSC-Semibold, PingFang SC;
      color: #ffe6bc;
      line-height: 25px;
    }
    .bannerBox_desc_btn {
      padding-top: 2px;
      width: 138px;
      height: 46px;
      font-family: PingFangSC-Medium, PingFang SC;
      color: #4f2618;
      cursor: pointer;
      transition: all 0.3s;
      margin-right: 12px;
      position: relative;
      border: 1px solid transparent;
      background: url("../../../assets/img/index/bannerBtn.png");
      background-size: 138px 46px;
    }
    .bannerBox_desc_btn:first-child {
      margin-left: 20px;
    }
    .bannerBox_desc_btn {
      .news {
        position: absolute;
        top: -12px;
        right: -18px;
        height: 22.5px;
        display: flex;
        align-items: center;
        img {
          width: 36.5px;
          height: 22.5px;
        }
      }
    }
  }
}
/deep/.ivu-modal {
  top: 200px;
  .ivu-modal-content {
    background: transparent;
    box-shadow: none;
    .ivu-modal-body {
      padding: 0;
    }
    .ivu-modal-close {
      top: -30px;
      right: -30px;
      .ivu-icon-ios-close {
        font-size: 28px;
        font-weight: 600;
        color: white;
      }
    }
  }
}
</style>
